export interface SortMenuOption {
  option: SortOptions;
  order: 'desc' | 'asc';
}

export enum SortOptions {
  DATE_CREATED = 'created_at',
  ALPHABETICALLY = 'name',
  ALPHABETICALLY_DISPLAY = 'display_name',
  LAST_MODIFIED = 'modified_at',
  STATUS = 'status',
  LOCATIONS_COUNT = 'locations_count',
  CHANNEL_TYPE = 'channel_type',
}

export interface SubheaderWithSortingProps {
  title: string;
  numOfSelected?: number;
  numResults?: number;
  isSelectedAll?: boolean;
  onSelectAllClick?: () => void;
  selectedSortOption: SortMenuOption;
  onSortChange: (selectedOption: SortMenuOption) => void;
  totalCount?: number;
  isReplacementComponent?: boolean;
  pageSize?: number;
  onPageSizeChange?: (pageSize: number) => void;
  page?: number;
}
export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}
